module.exports = __webpack_public_path__ + "img/emoji_100.ab8fc36a.png";